// Centralized named constants for UI and validation
export const UI = {
  RECENT_VENDORS_LIMIT: 4,
  FOCUS_DELAY_MS: 100,
  DESCRIPTION_MAX_LENGTH: 255,
  DASHBOARD_TOP_CATEGORIES: 5,
  TOAST_STACK_LIMIT: 3,
  TOAST_SUCCESS_DURATION_MS: 2500,
  TOAST_INFO_DURATION_MS: 3500,
  TOAST_ERROR_NON_CRITICAL_DURATION_MS: 7000,
  TOAST_MOBILE_SIDE_MARGIN_PX: 12,
  TOAST_MOBILE_BOTTOM_OFFSET_PX: 96,
};
